import React, { Component } from "react";
import { Route } from "react-router-dom";
import { Container } from "semantic-ui-react";
import ErrorBoundary from "../../ErrorBoundary";
import AddHeader from "../../shared/AddHeader";
import SalespersonTable from "./SalespersonTable";
import SalespersonAddForm from "./SalespersonAddForm";
import SalespersonDetail from "./SalespersonDetail";

export default class Salespeople extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      error: null,
    };

    this.onFormToggle = this.onFormToggle.bind(this);
    this.onSalespersonAdd = this.onSalespersonAdd.bind(this);
  }

  onFormToggle(event) {
    event.preventDefault();
    const { showForm } = this.state;

    this.setState({ showForm: !showForm });
  }

  onSalespersonAdd(status) {
    status ? this.setState({ showForm: false }) : null;
  }

  render() {
    const { match } = this.props;
    const { showForm } = this.state;

    return (
      <Container>
        <ErrorBoundary>
          <Route
            exact
            path={`${match.path}`}
            render={() => (
              <div>
                <AddHeader
                  headerText="Salespeople"
                  onClick={this.onFormToggle}
                  showForm={showForm}
                />
                {showForm ? (
                  <SalespersonAddForm onAdd={this.onSalespersonAdd} />
                ) : (
                  <SalespersonTable />
                )}
              </div>
            )}
          />
          <Route
            path={`${match.path}/:salespersonId`}
            component={(props) => (
              <SalespersonDetail id={props.match.params.salespersonId} />
            )}
          />
        </ErrorBoundary>
      </Container>
    );
  }
}
